var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.activeTab === 'all' || _vm.content.estateType === _vm.activeTab)?_c('CommonCard',{attrs:{"annotation":_vm.annotation,"content":_vm.content,"bookingStatus":_vm.bookingStatus,"cardOptions":_vm.cardOptions,"isBooking":true,"steps":_vm.steps,"modify":"booking-card"},on:{"deleteBooking":_vm._deleteCard}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }